"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

/**
 * Home page component.
 * With server-side tenant detection via TenantHydrator in layout.tsx:
 * - If tenant is valid (has _id), redirect to /menu
 * - If tenant is invalid, TenantHydrator already shows LandingPage
 */
export default function Home() {
  const router = useRouter();
  const tenant = useSelector((state: RootState) => state.tenant);

  useEffect(() => {
    // If tenant has been hydrated with a valid _id, go to menu
    if (tenant._id) {
      router.replace("/menu");
    }
  }, [tenant._id, router]);

  // While waiting for redirect (tenant is valid but redirect hasn't happened yet)
  if (tenant._id) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  // If no valid tenant, TenantHydrator in layout handles showing LandingPage
  // This fallback handles the brief moment before hydration completes
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
    </div>
  );
}
